"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBarNotificationEmptyState = void 0;
const react_1 = __importDefault(require("react"));
const Text_1 = require("../../../../../Text");
const View_1 = require("../../../../../View");
exports.AppBarNotificationEmptyState = react_1.default.memo(({ text, ['data-selector-id']: dataSelectorId }) => (react_1.default.createElement(View_1.View, { "data-selector-id": dataSelectorId, spaceAll: View_1.INDENT.l, align: View_1.VIEW_ALIGN.center, distribution: View_1.VIEW_DISTRIBUTION.center, backgroundView: View_1.VIEW_BG_VIEW.neutral },
    react_1.default.createElement(Text_1.Text, null, text))));
exports.AppBarNotificationEmptyState.displayName = 'AppBarNotificationEmptyState';
//# sourceMappingURL=AppBarNotificationEmptyState.js.map